import { Deserializable } from '../protocols/deserializable';

export class RemittancePaymentStatus implements Deserializable {
  public id!: number;
  public name!: string;

  onDeserialize() {}
}
